import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=a3ea457c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ea457c')) {
      api.createRecord('a3ea457c', component.options)
    } else {
      api.reload('a3ea457c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=a3ea457c&", function () {
      api.rerender('a3ea457c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2q5k2RPyiYcYB/JS/imageCarousel.vue"
export default component.exports